module.exports = __webpack_public_path__ + "static/media/buff.6f96e872.png";